<template>
  <el-dialog width="600px" title="客户对账" v-model="isvisible">
    <el-form
      ref="customerFormRef"
      :model="customerForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="客户对账状态" prop="cusstatus">
        <el-select
          v-model="customerForm.cusstatus"
          placeholder="选择客户对账状态"
          style="width: 100%"
        >
          <el-option label="已对账" :value="1" />
          <el-option label="未对账" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户收款状态" prop="cuspaystatus">
        <el-select v-model="customerForm.cuspaystatus" placeholder="客户收款状态" style="width: 100%">
          <el-option label="已收款" :value="1" />
          <el-option label="未收款" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="差异补偿金额" prop="cuscompensation">
        <el-input
          v-model.trim="customerForm.cuscompensation"
          placeholder="请输入差异补偿金额"
        />
      </el-form-item>
      <!-- customerForm.cuspaidamount -->
      <el-form-item label="应收金额" prop="cuspaidamount">
        <el-input
          v-model.trim="computedAmount"
          placeholder="请输入应收金额"
        />
      </el-form-item>

      <el-form-item label="客户结算状态" prop="cussetstatus">
        <el-select
          v-model="customerForm.cussetstatus"
          placeholder="选择客户结算状态"
          style="width: 100%"
        >
          <el-option label="已结算" :value="1" />
          <el-option label="未结算" :value="2" />
          <el-option label="已抵扣" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="收款开票" prop="cusistax">
        <el-select
          v-model="customerForm.cusistax"
          placeholder="选择收款开票"
          style="width: 100%"
        >
          <el-option label="有" :value="1" />
          <el-option label="无" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户对账备注" prop="cusnote">
        <el-input
          type="textarea"
          autosize
          v-model.trim="customerForm.cusnote"
          placeholder="请输入客户对账备注"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doFinanceCustomer" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
    <script setup>
import { ref, defineExpose, defineEmits, computed } from "vue";
import { ElMessage } from "element-plus";
import { saveOrderVerify } from "@/api/order/verify";

let timer;

const emit = defineEmits(["click"]); // 声明父触发事件

const loading = ref(false);

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const computedAmount = computed(() => {
  console.log(customerForm.value.saleamount, customerForm.value.cuscompensation)
  let amount = customerForm.value.cuspaidamount?customerForm.value.cuspaidamount:customerForm.value.saleamount
  if (customerForm.value.cuscompensation) {
    return (amount - customerForm.value.cuscompensation).toFixed(2)
  } else {
    return amount - 0
  }
})

const customerFormRef = ref();
const customerForm = ref({
  orderid: "",
  cusstatus: "",
  cuspaystatus: "",
  cuscompensation: 0,
  cuspaidamount: "",
  saleamount:"",
  cussetstatus: "",
  cusistax: "",
  cusnote: "",
});

const customerMethod = (obj) => {
  console.log(obj)
  customerForm.value = {
    orderid: obj.orderid,
    cusstatus: obj.cusstatus,
    cuspaystatus: obj.cuspaystatus,
    cuscompensation: obj.cuscompensation,
    cuspaidamount: obj.cuspaidamount,
    saleamount:obj.saleamount,
    cussetstatus: obj.cussetstatus,
    cusistax: obj.cusistax,
    cusnote: obj.cusnote,
  };
};

defineExpose({ changeVisible, customerMethod });

const doFinanceCustomer = () => {
  customerFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    //customerForm.value.orderid = receiverInfo.value.orderid;
    let query = JSON.parse(JSON.stringify(customerForm.value)); 
    query.cuspaidamount = computedAmount.value
    delete query.saleamount
    console.log(query)

    saveOrderVerify(query).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog()
          emit('click')
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  customerFormRef.value.resetFields();
  clearTimeout(timer);
};

const validateDecimal = (rule, value, callback) => {
  if (value===''|| typeof(value)=='undefined') {
    callback();
  }
  const reg = /^(\d+\.?)?\d{0,2}$/;
  if (!String(value).match(reg)) {
    callback(new Error("只能填写整数、小数须保留两位小数"));
  } else {
    callback();
  }
};
//表单验证规则
const rules = ref({
  // cusstatus: [
  //   {
  //     required: true,
  //     message: "请选择客户对账状态",
  //     trigger: "change",
  //   },
  // ],
  cuscompensation: [
    // {
    //   required: true,
    //   message: "请输入差异补偿金额",
    //   trigger: "blur",
    // },
    {
      required: true,
      validator: validateDecimal,
      trigger: "blur",
    },
  ],
  cuspaidamount: [
    // {
    //   required: true,
    //   message: "请输入应收金额",
    //   trigger: "blur",
    // },
    {
      // required: true,
      validator: validateDecimal,
      trigger: "blur",
    },
  ],
  // cussetstatus: [
  //   {
  //     required: true,
  //     message: "请选择客户结算状态",
  //     trigger: "change",
  //   },
  // ],
  // cusistax: [
  //   {
  //     required: true,
  //     message: "请选择收款开票",
  //     trigger: "change",
  //   },
  // ],
  cusnote: [
    {
      min: 2,
      max: 200,
      message: "备注长度2到200",
      trigger: "blur",
    },
  ],
});
</script>
    <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>